import {Url} from '@wendig/lib'
import config from '../lib/dotenv'
import {default as st} from 'strftime'
// import Article from '../lib/article'

// const open = (record, event = null) => {
//   if (event) event.preventDefault()

//   const item = (
//     record instanceof Article ?
//     record :
//     new Article(record)
//   )

//   const url = Url.current()
//   url.setHashPath(`/records/${item.id()}`)
//   url.apply()
// }

const params = () => {
  const defaults = {
    page: 1,
    per_page: 12
  }

  const url = Url.current()
  
  return Object.assign(defaults, url.hashParams())
}

const indexFor = (response, id) => {
  for (let i = 0; i < response.results.length; i++) {
    const record = response.results[i]

    if (record.id == id) {
      return i
    }
  }

  return -1
}

const baseUrl = () => {
  const url = Url.current()
  const r = url.resource().split('#')[0]
  return `${url.origin()}${r}`
}

const strftime = st.localizeByIdentifier('de_DE').timezone(0)

export {
  baseUrl,
  indexFor,
  // open,
  params,
  strftime
}